// AdminLogin.jsx

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Admin.css";
import { HostApi } from "../../configuration";

const AdminLogin = () => {
 const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleLogin = async () => {

    try {

      const res = await axios.post(`${HostApi()}/api/Advisor/login`,
        {
          UserName:userName,
          password:password
        }
      );

      //localStorage.setItem("token", res.data.token);
      if(res.data.message=="Login Success"){
        localStorage.setItem("isAdminLogin", "true");
      navigate("/admin-panel");
      }

    } catch {
      alert("Invalid Login");
    }
  };

  return (
    <div className="login-page">

      <div className="login-box">

        <h2>Admin Login</h2>

        <input
          type="Username"
          placeholder="UserName"
          onChange={(e) => setUserName(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button onClick={handleLogin}>
          Login
        </button>

      </div>

    </div>
  );
};

export default AdminLogin;